import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { Typography } from "@packages/ui";
import NavBar from "./NavBar";
import TopBar from "./TopBar";
import SnackBar from "../SnackBar";
import * as appActions from "../../actions/appActions";
import * as constants from "../../utils/constants";
import { useCurrentRental } from "../../hooks/rentalHooks";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    overflow: "hidden",
    width: "100%",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    marginTop: 64,
    [theme.breakpoints.up("lg")]: {
      marginLeft: 256,
    },
  },
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
  },
  content: {
    flex: "1 1 auto",
    minHeight: "90vh",
    marginLeft: 15,
    marginRight: 15,
  },
  mainContent: {
    minHeight: "80vh",
  },
  footer: {
    textAlign: "center",
    width: "100%",
    borderTop: `1px solid ${theme.palette.primary.main}`,
    zIndex: 500,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 5,
    paddingRight: 5,
  },
}));

const DashboardLayout = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const currentRental = useCurrentRental();

  return (
    <div className={classes.root}>
      <TopBar
        onMobileNavOpen={() => {
          setMobileNavOpen(true);
          dispatch(appActions.closePopper());
        }}
      />
      <SnackBar />
      <NavBar onMobileClose={() => setMobileNavOpen(false)} openMobile={isMobileNavOpen} />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <div className={classes.mainContent}>
              <Outlet />
            </div>
            <div className={classes.footer}>
              {currentRental?.brand === "Ace" ? (
                <Typography style={{ fontSize: 13 }}>
                  ©{new Date().getFullYear()} Ace Rental Cars
                </Typography>
              ) : currentRental?.brand === "Firefly" ? (
                <Typography style={{ fontSize: 13 }}>
                  ©{new Date().getFullYear()} Firefly Rent A Car LLC. Firefly is a trademark of
                  Hertz Systems, Inc. All rights reserved.
                </Typography>
              ) :  currentRental?.brand === "Dollar" ? (
                <Typography style={{ fontSize: 13 }}>
                  ©{new Date().getFullYear()} Dollar Car Rental. Dollar is a trademark of
                  Hertz Systems, Inc. All rights reserved.
                </Typography>
              ) : currentRental?.brand === "Thrifty" ? (
                <Typography style={{ fontSize: 13 }}>
                  ©{new Date().getFullYear()} Thrifty Car Rental. Thrifty is a trademark of
                  Hertz Systems, Inc. All rights reserved.
                </Typography>
              ) :(
                <Typography style={{ fontSize: 13 }}>
                  ©{new Date().getFullYear()} The Hertz Corporation. Hertz is committed to your
                  privacy. For details, please read our{" "}
                  <a href={constants.HERTZ_PRIVACY_POLICY}>Privacy Policy</a>.
                </Typography>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
